import { Link } from "react-router-dom";
import posDeviceData from "../../../lib/Json/prouctData.json";

function DeviceListing() {
  const androidDevices = posDeviceData?.filter((device) => device.deviceType === 1) || [];
  const desktopAndroidDevices = posDeviceData?.filter((device) => device.deviceType === 2) || [];
  const windowsDevices = posDeviceData?.filter((device) => device.deviceType === 3) || [];

  const getCardWidthClass = (itemCount) => {
    if (itemCount === 3) {
      return "w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.33%-16px)] group flex flex-col h-full";
    }
    if (itemCount === 2) {
      return "w-full sm:w-[calc(50%-12px)] lg:w-[calc(50%-12px)] lg:max-w-md group flex flex-col h-full";
    }
    if (itemCount === 1) {
      return "w-full sm:w-[calc(50%-12px)] lg:w-96 lg:max-w-md group flex flex-col h-full";
    }
    return "w-full sm:w-[calc(50%-12px)] lg:w-[calc(25%-18px)] lg:max-w-xs group flex flex-col h-full";
  };

  return (
    <div>
      <h4 className="text-base sm:text-xl poppins_semibold mb-5 bg-slate-800 text-white text-center py-2 rounded-md">
        Portable Mobile Devices - Android
      </h4>
      <div className="flex flex-wrap justify-center gap-6 mb-10">
        {androidDevices.map((deviceData) => {
          return (
            <Link
              key={deviceData.id}
              className={getCardWidthClass(androidDevices.length)}
              to={`/product/${deviceData.id}`}
            >
              <div class="relative flex h-full w-full flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md">
                <div class="relative flex h-48 sm:h-56 items-center justify-center p-5 rounded-t-lg bg-[radial-gradient(circle,#C1C0BC,#D7D6D2)] image-wrapper image-shine">
                  <img
                    className="max-h-full max-w-full object-contain group-hover:scale-95 transform duration-300"
                    src={deviceData.productImage}
                    alt={deviceData.name}
                  />
                  {deviceData?.isNew && (
                    <div className="absolute top-3 right-3">
                      <img src="/images/elements/star.png" alt="New Arrival" className="w-10 spin-slow" />
                      <img src="/images/elements/new.png" alt="New Arrival" className="w-10 absolute top-0 right-0" />
                    </div>
                  )}
                </div>
                <div class="mt-4 px-4 pb-4 flex flex-col flex-grow justify-between">
                  <div>
                    <div className="w-5 mb-2">
                      <img src={deviceData.os} alt={deviceData.name} />
                    </div>
                    <div
                      className="text-md poppins_semibold tracking-tight text-gray-900 group-hover:text-[#2874F0] transition-all duration-300"
                      dangerouslySetInnerHTML={{ __html: deviceData.name }}
                    />
                    <ul className="list-disc ml-5 py-3 space-y-1 text-xs sm:text-[13px] poppins_light">
                      {deviceData?.feature?.map((featureData, featureIndex) => (
                        <li
                          key={featureIndex}
                          className="text-[#C2C2C2] leading-5 tracking-wide"
                        >
                          <span className="text-black">{featureData}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <a
                    href="#"
                    class="flex items-center justify-center rounded-md bg-[#f6892f] px-5 py-2.5 text-center text-sm poppins_medium text-white group-hover:bg-[#ffb77c] focus:outline-none focus:ring-4 focus:ring-blue-300 mt-2"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      {/* <h4 className="text-base sm:text-xl poppins_semibold my-5 bg-slate-800 text-white text-center py-2 rounded-md">
        Desktop Devices - Android
      </h4> */}
      <div className="flex flex-wrap justify-center gap-6 mb-10">
        {desktopAndroidDevices.map((deviceData) => {
          return (
            <Link
              key={deviceData.id}
              className={getCardWidthClass(desktopAndroidDevices.length)}
              to={`/product/${deviceData.id}`}
            >
              <div class="relative flex h-full w-full flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md">
                <div class="relative flex h-48 sm:h-56 items-center justify-center p-5 rounded-t-lg bg-[radial-gradient(circle,#C1C0BC,#D7D6D2)] image-wrapper image-shine">
                  <img
                    className="max-h-full max-w-full object-contain group-hover:scale-95 transform duration-300"
                    src={deviceData.productImage}
                    alt={deviceData.name}
                  />
                </div>
                <div class="mt-4 px-4 pb-4 flex flex-col flex-grow justify-between">
                  <div>
                    <div className="w-5 mb-2">
                      <img src={deviceData.os} alt={deviceData.name} />
                    </div>
                    <div
                      className="text-md poppins_semibold tracking-tight text-gray-900 group-hover:text-[#2874F0] transition-all duration-300"
                      dangerouslySetInnerHTML={{ __html: deviceData.name }}
                    />
                    <ul className="list-disc ml-5 py-3 space-y-1 text-xs sm:text-[13px] poppins_light">
                      {deviceData?.feature?.map((featureData, featureIndex) => (
                        <li
                          key={featureIndex}
                          className="text-[#C2C2C2] leading-5 tracking-wide"
                        >
                          <span className="text-black">{featureData}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <a
                    href="#"
                    class="flex items-center justify-center rounded-md bg-[#f6892f] px-5 py-2.5 text-center text-sm font-medium text-white group-hover:bg-[#ffb77c] focus:outline-none focus:ring-4 focus:ring-blue-300 mt-2"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <h4 className="text-base sm:text-xl poppins_semibold my-5 bg-slate-800 text-white text-center py-2 rounded-md">
        Desktop Devices - Windows
      </h4>
      <div className="flex flex-wrap justify-center gap-6">
        {windowsDevices.map((deviceData) => {
          return (
            <Link
              key={deviceData.id}
              className={getCardWidthClass(windowsDevices.length)}
              to={`/product/${deviceData.id}`}
            >
              <div class="relative flex h-full w-full flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-md">
                <div class="relative flex h-48 sm:h-56 items-center justify-center p-5 rounded-t-lg bg-[radial-gradient(circle,#C1C0BC,#D7D6D2)] image-wrapper image-shine">
                  <img
                    className="max-h-full max-w-full object-contain group-hover:scale-95 transform duration-300"
                    src={deviceData.productImage}
                    alt={deviceData.name}
                  />
                </div>
                <div class="mt-4 px-4 pb-4 flex flex-col flex-grow justify-between">
                  <div>
                    <div className="w-5 mb-2">
                      <img src={deviceData.os} alt={deviceData.name} />
                    </div>
                    <div
                      className="text-md poppins_semibold tracking-tight text-gray-900 group-hover:text-[#2874F0] transition-all duration-300"
                      dangerouslySetInnerHTML={{ __html: deviceData.name }}
                    />
                    <ul className="list-disc ml-5 py-3 space-y-1 text-xs sm:text-[13px] poppins_light">
                      {deviceData?.feature?.map((featureData, featureIndex) => (
                        <li
                          key={featureIndex}
                          className="text-[#C2C2C2] leading-5 tracking-wide"
                        >
                          <span className="text-black">{featureData}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <a
                    href="#"
                    class="flex items-center justify-center rounded-md bg-[#f6892f] px-5 py-2.5 text-center text-sm font-medium text-white group-hover:bg-[#ffb77c] focus:outline-none focus:ring-4 focus:ring-blue-300 mt-2"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default DeviceListing;
